import { DropdownMenu as M } from "radix-ui";
import type { ReactNode } from "react";
import { Kbd } from "./kbd";

export const Menu = M.Root;
export const MenuTrigger = M.Trigger;

export function MenuContent({
  children,
  align = "start",
}: {
  children: ReactNode;
  align?: "start" | "end";
}) {
  return (
    <M.Portal>
      <M.Content
        align={align}
        sideOffset={6}
        className="z-50 min-w-56 rounded-lg border border-line bg-raised p-1 text-sm shadow-2xl"
      >
        {children}
      </M.Content>
    </M.Portal>
  );
}

export function MenuItem({
  icon,
  children,
  keys,
  onSelect,
  danger,
  disabled,
}: {
  icon?: ReactNode;
  children: ReactNode;
  keys?: string;
  onSelect?: () => void;
  danger?: boolean;
  disabled?: boolean;
}) {
  return (
    <M.Item
      disabled={disabled}
      onSelect={onSelect}
      className={`flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 outline-none data-[disabled]:opacity-40 data-[highlighted]:bg-hover [&_svg]:size-4 ${danger ? "text-danger" : "text-fg"}`}
    >
      <span className="flex w-4 justify-center text-muted">{icon}</span>
      <span className="flex-1">{children}</span>
      {keys && <Kbd>{keys}</Kbd>}
    </M.Item>
  );
}

export function MenuSeparator() {
  return <M.Separator className="my-1 h-px bg-line" />;
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return (
    <M.Label className="px-2 pt-1.5 pb-1 text-[11px] text-faint uppercase tracking-wide">
      {children}
    </M.Label>
  );
}
